import React from 'react'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import AccountListSF from '../../components/connectedAccount/AccountListSF'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'

const AccountListPageUI = ({context, messageList, errorList, accountList, onRefreshClick, onConnectionUpdate}) =>
  <PrivatePageSF context={context} className='pg_conn_acc' backLink='/settings/user/fin'
    messageList={messageList} headerMessageKey='c_connected_accounts'
    centered={!accountList && !errorList}
  >
    {
      !accountList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      accountList && accountList.length !== 0 &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/settings/user/fin' messageList={messageList} titleMessageKey='c_connected_accounts' />
        <AccountListSF context={context} accountList={accountList} messageList={messageList}
          onRefreshClick={onRefreshClick} onConnectionUpdate={onConnectionUpdate}
        />
      </div>
    }
  </PrivatePageSF>

export default AccountListPageUI
